import { BUTTON } from '@lumapps/wrex-button/constants';
import { CODE_BLOCK } from '@lumapps/wrex-code-block/constants';
import { COLUMN, COLUMNS } from '@lumapps/wrex-columns/constants';
import { EMBEDDED_MAP } from '@lumapps/wrex-embedded-map/constants';
import { EMBEDDED_VIDEO } from '@lumapps/wrex-embedded-video/constants';
import { ALIGNED_IMAGE_WRAPPER, IMAGE_GROUP } from '@lumapps/wrex-enhanced-image/constants';
import { FILE } from '@lumapps/wrex-file/constants';
import { HTMLPasteOptions } from '@lumapps/wrex-html-paste/types';
import { IFRAME } from '@lumapps/wrex-iframe/constants';
import { INFO_PANEL } from '@lumapps/wrex-info-panel/constants';
import { LINK_PREVIEW } from '@lumapps/wrex-link-preview/constants';
import { LINK } from '@lumapps/wrex-link/constants';
import { LIST_ITEM, ORDERED_LIST, UNORDERED_LIST } from '@lumapps/wrex-list/constants';
import { PLAY_VIDEO } from '@lumapps/wrex-play-video/constants';
import { QUOTE_BLOCK } from '@lumapps/wrex-quote/constants';
import { T_D, T_H, T_R, TABLE } from '@lumapps/wrex-table/constants';
import {
    BOLD,
    COLORED,
    DIVIDER,
    HEADING,
    INLINE_CODE,
    ITALIC,
    PARAGRAPH,
    STRIKETHROUGH,
    UNDERLINE,
} from '@lumapps/wrex-typography/constants';
import { USER_MENTION } from '@lumapps/wrex-user-mention/constants';

import { Wrex } from '../../../types';
import { getHtmlPasteOptions } from '../../../utils/getHtmlPasteOptions';
import { fromHTML } from '../../html/fromHTML/fromHTML';

/**
 * List of element type that will be used from the Google Translate result
 */
const ELEMENT_TYPE_TO_TRANSLATE = [
    PARAGRAPH,
    HEADING,
    UNORDERED_LIST,
    ORDERED_LIST,
    QUOTE_BLOCK,
    TABLE,
    IMAGE_GROUP,
    ALIGNED_IMAGE_WRAPPER,
    LINK_PREVIEW,
];

export const htmlValuesToSlate = ({
    slate,
    slateHtml,
    pasteOptions,
}: {
    slate?: Wrex.Nodes;
    slateHtml: string;
    pasteOptions: Required<Pick<HTMLPasteOptions, 'colorPalette'>>;
}) => {
    const htmlPasteOptions = getHtmlPasteOptions({
        elements: [
            PARAGRAPH,
            HEADING,
            CODE_BLOCK,
            INFO_PANEL,
            INLINE_CODE,
            IMAGE_GROUP,
            UNORDERED_LIST,
            ORDERED_LIST,
            LIST_ITEM,
            USER_MENTION,
            LINK_PREVIEW,
            LINK,
            TABLE,
            T_R,
            T_D,
            T_H,
            QUOTE_BLOCK,
            EMBEDDED_MAP,
            EMBEDDED_VIDEO,
            PLAY_VIDEO,
            IFRAME,
            FILE,
            DIVIDER,
            BUTTON,
            COLUMNS,
            COLUMN,
        ],
        marks: [BOLD, ITALIC, COLORED, UNDERLINE, STRIKETHROUGH],
    });
    if (!slate) {
        const htmlToSlate = fromHTML(slateHtml, {
            ...htmlPasteOptions,
            ...pasteOptions,
        });

        return htmlToSlate;
    }
    const translatedSlate = slate;

    if (slate.length === 0) {
        return undefined;
    }

    const htmlObject = document.createElement('div');
    htmlObject.innerHTML = slateHtml;

    const values: string[] = [];
    Array.from(htmlObject.children).forEach((element: Element) => {
        values.push(element.outerHTML);
    });

    for (let i = 0; i < translatedSlate.length; i++) {
        if (ELEMENT_TYPE_TO_TRANSLATE.includes(translatedSlate[i].type)) {
            const value = values[i];
            const htmlToSlate = fromHTML(value, {
                ...htmlPasteOptions,
                ...pasteOptions,
            });

            [translatedSlate[i]] = htmlToSlate;
        }
    }

    return translatedSlate;
};
